module.exports = __webpack_public_path__ + "img/close.5d8fa210.svg";